import { render, staticRenderFns } from "./SkupForma.vue?vue&type=template&id=6c94bc9f&scoped=true&"
import script from "./SkupForma.vue?vue&type=script&lang=js&"
export * from "./SkupForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94bc9f",
  null
  
)

export default component.exports